import axios from 'axios'
import { getBaseUrl, isProdMode } from '@/utils/helpers'

const isProduction = isProdMode() || process.env.NODE_ENV === 'production'
const baseServer = getBaseUrl()

const maintenanceApi = axios.create({
  baseURL: `https://${isProduction ? 'api' : 'gc-api-dev'}.${baseServer}/`,
  timeout: 300000 // optional, override default
})

export default maintenanceApi